import { EWallMaterial, WallMaterial } from "../../../../shared/dictionary";
import DottedList from "../../../../ui/dottedList";
import styles from "./styles.module.scss";

interface IAboutApartment {
  commissioningYear?: number;
  wallMaterial?: EWallMaterial;
  floorCount?: number;
  address?: string;
}

const AboutBuilding = ({
  commissioningYear,
  wallMaterial,
  floorCount,
  address,
}: IAboutApartment) => {
  return (
    <div className={styles.aboutBuilding}>
      <div className={styles.aboutBuilding__container}>
        <div className={styles.aboutBuilding__title}>Дом</div>
        <div className={styles.aboutBuilding__address}>
          <DottedList
            items={[
              {
                label: "Адрес",
                value: address ?? "Неизвестно",
              },
            ]}
          />
        </div>
        <div className={styles.aboutBuilding__commissioningYear}>
          <DottedList
            items={[
              {
                label: "Ввод в эксплуатацию",
                value: commissioningYear ?? "Неизвестно",
              },
            ]}
          />
        </div>
        <div className={styles.aboutBuilding__wallMaterial}>
          <DottedList
            items={[
              {
                label: "Материал стен",
                value: WallMaterial.label(wallMaterial) ?? "Неизвестно",
              },
            ]}
          />
        </div>
        <div className={styles.aboutBuilding__floorCount}>
          <DottedList
            items={[
              {
                label: "Этажей",
                value: floorCount ?? "Неизвестно",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutBuilding;
